module.exports = __webpack_public_path__ + "static/img/6.516954d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/1/zh/6.png
// module id = UsXX
// module chunks = 0